import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@teqplay/ui'
import { useTranslations } from 'next-intl'

import { Link } from '@/i18n/navigation'
import { useAnalytics } from '@/app/lib/analytics'

interface IProps {
  message?: string
  messageKey?: string
  children: React.ReactNode
  notChild?: boolean
  hide?: boolean
}

interface InfoTooltipContentProps {
  message?: string
  messageKey?: string
}

// Reusable tooltip content component
export const InfoTooltipContent = ({ message, messageKey }: InfoTooltipContentProps) => {
  const t = useTranslations('toolTip')
  const { trackTooltipLearnMore } = useAnalytics()

  // Use messageKey if provided, otherwise fall back to message
  const tooltipText = messageKey ? t(messageKey) : message

  const handleLearnMoreClick = () => {
    trackTooltipLearnMore({
      tooltipType: messageKey || 'custom'
    })
  }

  return (
    <TooltipContent
      style={{
        zIndex: 1001,
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        borderRadius: 3,
        padding: 8
      }}
    >
      <p style={{ color: '#fff' }}>{tooltipText}</p>
      <Link href={'/about'} onClick={handleLearnMoreClick}>
        <u>{t('learnMore')}</u>
      </Link>
    </TooltipContent>
  )
}

const InfoToolTip = (props: IProps) => {
  if (props.hide) {
    return <>{props.children}</>
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild={!props.notChild}>{props.children}</TooltipTrigger>
        <InfoTooltipContent message={props.message} messageKey={props.messageKey} />
      </Tooltip>
    </TooltipProvider>
  )
}

export default InfoToolTip
